import * as React from 'react';
import { AuthContext } from '../../AuthContext/AuthContext';
import { loader } from '../../Func_genericas/loader';
import { cores, imagens } from '../../Func_genericas/valores_estaticos';
import { OtpInput } from 'reactjs-otp-input';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { useNavigate } from 'react-router-dom';
import { post_login } from '../../Services/tokenConfig';

interface I_aux {
    email: string | undefined;
    password: string | undefined;
    set_open_code_insert: React.Dispatch<React.SetStateAction<boolean>>;
}


export const Preenchercodigo: React.FC<I_aux> = ({ email, password, set_open_code_insert }) => {

    const auth = React.useContext(AuthContext);

    // const { remainingTime } = useCountdown({ duration: 30, colors: '#abc' })
    const navigate = useNavigate();

    // VARIAVEIS  USESTATE
    const [codigo, set_codigo] = React.useState("");


    // FLAG USESTATE
    const [isLoading, setIsLoading] = React.useState(false);

    const submitLogin = async () => {

        setIsLoading(true);
        try {
            if (codigo !== undefined && !Number.isNaN(parseInt(codigo))) {

                if (password === undefined) {

                    let data = await post_login('', "reset_password", {
                        "payload": {
                            "email": email,
                            "secret_2fa": codigo,
                        }
                    })
                    if (data.status === 200) {

                        set_open_code_insert(false)
                    }

                } else {



                    let aux_obj = {
                        email: email,
                        password: password,
                        secret_2fa: codigo,

                    }

                    let res: any = await auth.signin_agricultor({ payload: aux_obj });

                    if (res.flag === false) {
                        set_open_code_insert(false)
                    } else {
                        navigate('/')
                    }
                }
            }

            setIsLoading(false);

        } catch (error: any) {
            navigate('/')
            setIsLoading(false);

        }
    };




    return (
        <div>

            {

                isLoading === true ?
                    loader() :
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'row',
                        height: '100vh',
                        overflowY: 'hidden',
                        overflowX: 'hidden',
                        backgroundColor: cores.cor1,


                    }}>

                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            backgroundColor: 'white',
                            height: '85%',
                            width: '45%',
                            borderRadius: 5,

                        }}>

                            <div style={{
                                alignItems: 'flex-end',
                                justifyContent: 'center',
                                display: 'flex',
                                flexFlow: 'row',
                                flex: 0.1,
                                maxHeight: '30%',

                            }}>


                                <div style={{
                                    fontWeight: 'bold',
                                    fontSize: 50,

                                }}>VULPES</div>

                                <img
                                    width="60%"
                                    height="50%"
                                    src={imagens.logo_login}
                                    alt="" />
                            </div>
                            <div style={{
                                alignItems: 'center',
                                justifyContent: 'center',
                                display: 'flex',
                                flex: 0.2,
                                paddingTop: '5%'

                            }}>

                                <CountdownCircleTimer
                                    size={125}
                                    isPlaying
                                    onComplete={() => set_open_code_insert(false)}
                                    duration={60}
                                    colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                                    colorsTime={[60, 40, 20, 0]}
                                >
                                    {({ remainingTime }) => remainingTime}
                                </CountdownCircleTimer>

                            </div>
                            <div
                                style={{
                                    flex: 0.1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginTop: '5%',

                                }}
                            >
                                Introduza aqui o seu código de autenticação.
                            </div>
                            <div style={{
                                flex: 0.2,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '10%',

                            }}>

                                <OtpInput
                                    containerStyle={{
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        alignSelf: 'center',
                                        display: 'flex',
                                        width: '50%',
                                        flexDirection: 'row',

                                    }}
                                    inputStyle={{
                                        marginLeft: 15,
                                        width: 40,
                                        height: 40,
                                        borderRadius: 3,
                                        borderWidth: 1,
                                        fontSize: 20,
                                    }}

                                    value={codigo}
                                    onChange={set_codigo}
                                    numInputs={6}
                                // separator={<span>-</span>} 
                                />
                            </div>

                            <div style={{
                                flex: 0.3,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',




                            }}
                            >
                                <button style={{
                                    backgroundColor: 'white',
                                    color: cores.cor1,
                                    fontSize: 20,
                                    // fontWeight: 'bold',

                                    borderRadius: 3,
                                    paddingTop: '1%',
                                    paddingBottom: '1%',
                                    paddingLeft: '10%',
                                    paddingRight: '10%',
                                    borderWidth: 1,
                                    borderBlockColor: cores.cor1,
                                    borderTopColor: cores.cor1,
                                    borderLeftColor: cores.cor1,
                                    borderRightColor: cores.cor1,
                                    // borderBottomColor: cores.cor1,
                                }}

                                    onClick={(e) => { submitLogin() }}
                                >
                                    Validar


                                </button>




                            </div>
                            <div style={{
                                flex: 0.1,
                                display: 'flex',
                                fontSize: 12,
                                marginBottom: '5%',

                            }}>
                                O código de autenticação foi enviado para o seu email, por favor verifique.

                            </div>
                        </div>



                    </div>
            }


        </div>
    );
}